// deps
import React, { useContext } from "react";

// internal-deps
import type { NRErrorInfo } from "@swiggy-private/js-utils";
import type { GetSwiggyHeadersResponsePayload, NativeBridge } from "@swiggy-private/native-bridge";
import { ResponseContext, ScreenNames, IApiConfigs } from "@swiggy-private/portal-dineout-context";

// components
import Cart from "./Cart";
import { TabContentLoadingSkeleton } from "../Skeleton/TabContentLoadingSkeleton";

interface ICartProps {
    sdk: NativeBridge;
    headers: GetSwiggyHeadersResponsePayload;
    clickAnalytics?: (clickObject: Record<string, unknown>) => void;
    impressionAnalytics?: (clickObject: Record<string, unknown>) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    genericOnclick: (_?: any, extraParams?: Record<string, any>) => Promise<void>;
    isCartEmpty?: boolean;
    emptyCartCtaHandler: VoidFunction;
    onInvalidWidget: (widgetName?: string) => void;
    onWidgetError: (error: NRErrorInfo, widgetName?: string) => void;
    onEmptyPage: () => void;
}

const CartPage = ({
    headers,
    sdk,
    clickAnalytics,
    impressionAnalytics,
    genericOnclick,
    isCartEmpty,
    emptyCartCtaHandler,
    onInvalidWidget,
    onWidgetError,
    onEmptyPage,
}: ICartProps) => {
    const { state } = useContext(ResponseContext);

    if (state.cart.loading) {
        return <TabContentLoadingSkeleton />;
    }

    return (
        <Cart
            cards={state.cart?.data?.success?.cards || []}
            popupConfigs={state.cart?.data?.success?.configs as IApiConfigs}
            sdk={sdk}
            headers={headers}
            clickAnalytics={clickAnalytics}
            impressionAnalytics={impressionAnalytics}
            genericOnclick={genericOnclick}
            isCartEmpty={isCartEmpty}
            emptyCartCtaHandler={emptyCartCtaHandler}
            onInvalidWidget={onInvalidWidget}
            onEmptyPage={onEmptyPage}
            onWidgetError={onWidgetError}
            screenName={ScreenNames.CART}
        />
    );
};
export default React.memo(CartPage);
